import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import MuiBreadcrumbs, { BreadcrumbsProps } from '@mui/material/Breadcrumbs';
import { SxProps, Theme, styled, transientOptions } from '../styles';
export interface Props {
  children: ReactNode;
  isOnContrasted?: boolean;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
}
const Root = styled(MuiBreadcrumbs, transientOptions)<BreadcrumbsProps & {
  $isOnContrasted: boolean;
}>(({
  $isOnContrasted,
  theme: {
    spacing,
    palette,
    typography,
    breakpoints
  }
}) => ({
  overflow: 'auto',
  paddingTop: spacing(2),
  marginBottom: spacing(2),
  '.MuiBreadcrumbs-ol': {
    flexWrap: 'nowrap',
    color: $isOnContrasted ? palette.text.onContrasted : palette.text.onMain
  },
  '& li': {
    flexShrink: 0,
    overflow: 'hidden',
    margin: 0,
    textOverflow: 'ellipsis',
    '& > a': {
      lineHeight: '40px',
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      },
      [breakpoints.up('sm')]: {
        fontSize: typography.pxToRem(14),
        lineHeight: 1
      }
    },
    '& > span': {
      fontWeight: 'normal'
    },
    '& > *': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'capitalize'
      }
    }
  },
  '& .MuiBreadcrumbs-separator': {
    fontSize: typography.subheadingSmall.fontSize,
    fontWeight: 'bold',
    padding: spacing(0, 1),
    color: 'inherit'
  }
}));
const Breadcrumbs = t0 => {
  const $ = _c(7);
  const {
    children,
    isOnContrasted: t1,
    "aria-label": ariaLabel,
    sx: t2
  } = t0;
  const isOnContrasted = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sx = t3;
  let t4;
  if ($[2] !== ariaLabel || $[3] !== children || $[4] !== isOnContrasted || $[5] !== sx) {
    t4 = <Root separator=">" $isOnContrasted={isOnContrasted} aria-label={ariaLabel} sx={sx}>{children}</Root>;
    $[2] = ariaLabel;
    $[3] = children;
    $[4] = isOnContrasted;
    $[5] = sx;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default Breadcrumbs;